/**
 *
 * clip actions
 *
 */
import { GET_DATA } from "./landing-page-constants";

/**
 * Load the landing page data, this action starts the request saga
 *
 * @param  {object} topicId  The topic unique identifier
 *
 * @return {object}     An action object with a type of GET_DATA
 */
export const getLandingPageData = (topicId) => ({
    type: GET_DATA,
    id: topicId,
});
